import { z } from 'zod';

// VITE_API_URL points the client at the API. In dev it's a cross-origin
// URL (http://localhost:5050). In prod, when the web + api ship under
// the same DigitalOcean app, it's empty → fetch('/api/...') resolves
// same-origin and the session cookie flows without CORS.
const EnvSchema = z.object({
  VITE_WEB_PUBLIC_BASE_URL: z.string().url().refine(value => /^https?:\/\//.test(value), 'Must be an HTTP or HTTPS URL').default('https://www.yrprealestate.com'),
  VITE_API_URL: z
    .string()
    .refine((v) => v === '' || /^https?:\/\//.test(v), 'Must be empty (same-origin) or a URL')
    .default('http://localhost:5050'),
  /** Browser-restricted Google Maps JS API key. Optional — when
   *  empty, the property map falls back to Leaflet + OpenStreetMap. */
  VITE_GOOGLE_MAPS_BROWSER_KEY: z.string().default(''),
  /** Mapbox GL token for the AVM map explorer (admin module). Optional —
   *  when empty the map card shows a configuration hint instead. */
  VITE_MAPBOX_TOKEN: z.string().default(''),
});

export const env = EnvSchema.parse(import.meta.env);
